import { render, staticRenderFns } from "./FamilyEdit.vue?vue&type=template&id=e1355b78&scoped=true&lang=pug"
import script from "./FamilyEdit.vue?vue&type=script&lang=ts"
export * from "./FamilyEdit.vue?vue&type=script&lang=ts"
import style0 from "./FamilyEdit.vue?vue&type=style&index=0&id=e1355b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1355b78",
  null
  
)

export default component.exports